import { Helper } from '../Helper';
export class ArrForEachFuncHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.getCallable({}));
        sb.emitOp(node, 'SWAP');
        sb.emitOp(node, 'DUP');
        sb.emitOp(node, 'ARRAYSIZE');
        sb.emitPushInt(node, 0);
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'GT');
            },
            each: (innerOptions) => {
                sb.emitOp(node, 'DUP');
                sb.emitHelper(node, options, sb.helpers.wrapNumber);
                sb.emitPushInt(node, 3);
                sb.emitOp(node, 'PICK');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PICK');
                sb.emitOp(node, 'PICKITEM');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PACK');
                sb.emitPushInt(node, 4);
                sb.emitOp(node, 'PICK');
                sb.emitHelper(node, sb.noPushValueOptions(innerOptions), sb.helpers.call);
            },
            incrementor: () => {
                sb.emitOp(node, 'INC');
            },
            cleanup: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                if (optionsIn.pushValue) {
                    sb.emitHelper(node, options, sb.helpers.wrapUndefined);
                }
            },
        }));
    }
}

//# sourceMappingURL=ArrForEachFuncHelper.js.map
